export enum Events {
  LOADING_START = 'LOADING_START',
  LOADING_END = 'LOADING_END',
  SIGNOUT = 'SIGNOUT',
}
